<template>
	<div class="h-100">
		<el-row :gutter="16">
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000806')"
					labelPosition="left"
					:labelSpan="11"
					:gutter="3"
					:inputValue="serviceProgram"
					:options="servicePrograms_"
					:onChange="value => onChange({ key: 'serviceProgram', value })"
					placeholder="Select"
				/>
			</el-col>
			<el-col :span="8">
				<sf-select-group
					:label="getMessage_('SWCC000743')"
					labelPosition="left"
					:labelSpan="11"
					:gutter="3"
					:inputValue="serviceUrl"
					:options="serviceUrls_"
					:onChange="value => onChange({ key: 'serviceUrl', value })"
					placeholder="Select"
					:disabled="serviceProgram === 'Java'"
				/>
			</el-col>
			<el-col :span="4">
				<sf-button line :onClick="bindSql">{{ getMessage_('SWCC000745') }}</sf-button>
			</el-col>
			<el-col :span="3">
				<sf-button line :onClick="exeStaticSql">{{ getMessage_('SWCC000746') }}</sf-button>
			</el-col>
		</el-row>
		<el-row style="height: calc(100% - 50px)">
			<compile-text-bar :historyRows="historyRows" />
		</el-row>
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import CompileTextBar from './CompileTextBar.vue';
import { utils } from '@sfaas/util';

export default {
	props: {
		historyRows: { type: Array, default: () => [] }
	},
	components: {
		CompileTextBar
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onChange(param) {
			// console.log('@@param', param);
			this.DEFAULT_ASSIGN({
				key: param.key,
				value: param.value
			});
		},
		bindSql() {
			this.postCompileSql_(this.selectedContent)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		exeStaticSql() {
			// && this.serviceUrl != null
			if (!utils.$sf_isNull(this.selectedContent.StaticSqlText) && this.serviceProgram != null) {
				this.$sf_toggleLoading(true);

				this.postExeSql_({
					...this.selectedContent,
					serviceUrl: this.serviceUrl || 'SFCC',
					serviceProgram: this.serviceProgram
				})
					.then(header => {
						if (utils.$sf_isNull(header)) {
							this.$sf_showMessage({ message: this.getMessage_('SWCC000765') });
						} else {
							this.$sf_toast({
								...this.$sf_setToastOption(header),
								message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
							});
						}
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('SWCC000750') });
			}
		}
	}
};
</script>
<style lang="scss"></style>
